import { all } from 'redux-saga/effects';
import societyForgotPasswordSaga from '../sagas/AuthSagas/forgotPasswordSaga'
import loginSaga from './AuthSagas/loginSaga';
import passwordResetSaga from './AuthSagas/passwordResetSaga';
import IPAddressSaga from './IPAddressSagas/IPAddressSaga';
import CtrlLocationSaga from './SocietyController/CtrlLocationSaga/CtrlLocationSaga';
import CtrlProfileSaga from './SocietyController/CtrlProfileSaga/CtrlProfileSaga';
import adminLoginSaga from './AuthSagas/AdminLoginSaga/adminLoginSaga';
import invoiceTypeSaga from './SocietyPortal/InvoiceTypeSaga/InvoiceTypeSaga';
import documentSeriesSaga from './SocietyPortal/DocumentSeriesSaga/DocumentSeriesSaga';
import societyProfileSaga from './SocietyPortal/SocietyProfileSaga/SocietyProfileSaga';
import InvoiceSettingSaga from './SocietyPortal/InvoiceSettingSaga/InvoiceSettingSaga';
import TariffHeadSaga from './SocietyPortal/TariffHeadSaga/TariffHeadSaga';
import societySaga from './SocietyPortal/SocietySaga/SocietySaga';
import vendorSaga from './SocietyPortal/VendorSaga/VendorSaga';
import WingsAndFlatsSaga from './WingsAndFlatsSagas/WingsAndFlatsSaga';
import TariffRateSaga from './SocietyPortal/TariffRateSaga/TariffRateSaga';
import InvoiceSaga from './SocietyPortal/InvoiceSaga/InvoiceSaga';
import TaxRuleSaga from './SocietyPortal/TaxRuleSaga/TaxRuleSaga'; // Added TaxRuleSaga
import ctrlCommunityManagementSaga from './SocietyController/CtrlCommunityManagementSaga/CtrlCommunityManagementSaga';
import ctrlBrandSaga from './SocietyController/CtrlBrandSaga/CtrlBrandSaga';
import CtrlEmployeeSaga from './SocietyController/CtrlEmployeeSaga/CtrlEmployeeSaga';
import CtrlSystemRoleSaga from './SocietyController/CtrlSystemRoleSaga/CtrlSystemRoleSaga';
import OccupantSaga from './SocietyPortal/OccupantSaga/OccupantSaga';
import MeterReadingSaga from './SocietyPortal/MeterReadingSaga/MeterReadingSaga';
import MeterSlabSaga from './SocietyPortal/MeterSlabSaga/MeterSlabSaga';
import JournalSaga from './SocietyPortal/JournalSaga/JournalSaga';
import OpeningBalanceSaga from './SocietyPortal/OpeningBalanceSaga/OpeningBalanceSaga';
import CreditDebitNoteSaga from './SocietyPortal/CreditDebitNoteSaga/CreditDebitNoteSaga';
import ReceiptSaga from './SocietyPortal/ReceiptSaga/ReceiptSaga';
import AccountsOpeningSaga from './SocietyPortal/AccountsOpeningSaga/AccountsOpeningSaga';
import AccountsClosingSaga from './SocietyPortal/AccountsClosingSaga/AccountsClosingSaga';
import MemberDaybookSaga from './SocietyPortal/MemberDaybookSaga/MemberDaybookSaga';
import GLAccountSaga from './SocietyPortal/GLAccountSaga/GLAccountSaga';
import FixedAssetSaga from './SocietyPortal/FixedAssetSaga/FixedAssetSaga';
import SocietyBankSaga from './SocietyPortal/SocietyBankSaga/SocietyBankSaga';
import CashBankSaga from './SocietyPortal/CashBankSaga/CashBankSaga';
import InvestmentSaga from './SocietyPortal/InvestmentSaga/InvestmentSaga';
import BRSSaga from './SocietyPortal/BRSSaga/BRSSaga';
import AccountReportsSaga from './SocietyPortal/AccountReportsSaga/AccountReportsSaga';
import InvoiceReportSaga from './SocietyPortal/InvoiceReportSaga/InvoiceReportSaga';
import rolePermissionSaga from './SocietyPortal/RolePermissionSaga/RolePermissionSaga';
import { accountLedgerReportWatcher } from './SocietyPortal/AccountLedgerReportSaga/AccountLedgerReportSaga';
import dashboardSaga from './SocietyPortal/DashboardSaga/DashboardSaga';
import ctrlDashboardSaga from './SocietyController/CtrlDashboardSaga/CtrlDashboardSaga';
import EmployeeSaga from './SocietyPortal/EmployeeSaga/EmployeeSaga';
import FlatTransferSaga from './SocietyPortal/FlatTransferSaga/FlatTransferSaga';
import ShareCertificateSaga from './SocietyPortal/ShareCertificateSaga/ShareCertificateSaga';
import taskSaga from './SocietyPortal/TaskSaga/TaskSaga';
import ComplaintSaga from './SocietyPortal/ComplaintSaga/ComplaintSaga';
import AttendanceSaga from './SocietyPortal/AttendanceSaga/AttendanceSaga';
import ShiftSaga from './SocietyPortal/ShiftSaga/ShiftSaga';
import NoticeSaga from './SocietyPortal/NoticeSaga/NoticeSaga';
import VisitorSaga from './SocietyPortal/VisitorSaga/VisitorSaga';
import VmsSaga from './SocietyPortal/VmsSaga/VmsSaga';
import MemberPortalSaga from './SocietyPortal/MemberPortalSaga/MemberPortalSaga';


export default function* rootSaga() {
  yield all([
    IPAddressSaga(),
    societyForgotPasswordSaga(),
    loginSaga(),
    passwordResetSaga(),
    adminLoginSaga(),
    ctrlCommunityManagementSaga(),
    ctrlBrandSaga(),
    CtrlEmployeeSaga(),
    CtrlSystemRoleSaga(),
    CtrlLocationSaga(),
    CtrlProfileSaga(),
    invoiceTypeSaga(),
    documentSeriesSaga(),
    societyProfileSaga(),
    InvoiceSettingSaga(),
    TariffHeadSaga(),
    societySaga(),
    vendorSaga(),
    WingsAndFlatsSaga(),
    TaxRuleSaga(),
    TariffRateSaga(),
    InvoiceSaga(),
    OccupantSaga(),
    MeterReadingSaga(),
    MeterSlabSaga(),
    JournalSaga(),
    OpeningBalanceSaga(),
    CreditDebitNoteSaga(),
    ReceiptSaga(),
    AccountsClosingSaga(),
    AccountsOpeningSaga(),
    MemberDaybookSaga(),
    GLAccountSaga(),
    FixedAssetSaga(),
    SocietyBankSaga(),
    CashBankSaga(),
    InvestmentSaga(),
    BRSSaga(),
    AccountReportsSaga(),
    InvoiceReportSaga(),
    rolePermissionSaga(),
    accountLedgerReportWatcher(),
    dashboardSaga(),
    ctrlDashboardSaga(),
    EmployeeSaga(),
    FlatTransferSaga(),
    ShareCertificateSaga(),
    taskSaga(),
    ComplaintSaga(),
    AttendanceSaga(),
    ShiftSaga(),
    NoticeSaga(),
    VisitorSaga(),
    VmsSaga(),
    MemberPortalSaga(),
  ])
}
